import React from 'react';
import PropTypes from 'prop-types'
import '../PrayTimesTable.css'
import moment from 'moment-hijri'
import prayTimes from '../PrayTimes'

class PrayTimesTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getDates(startDate, endDate) {
        var dateArray = [];
        var currentDate = startDate;
        while (currentDate < endDate) {
            dateArray.push(new Date (currentDate));
            currentDate.setDate(currentDate.getDate()+1);
        }
        return dateArray;
    }

    renderTable() {
        var startDate = new Date(this.props.date);
        if (moment(startDate).format('iM') == "8") {
            startDate.setDate(startDate.getDate()+1);
        }
		var endDate = new Date(startDate.getFullYear(), startDate.getMonth()+1, startDate.getDate());
        
        return this.getDates(startDate,endDate).map((currentDate) => {
            prayTimes.setMethod(this.props.method);
            prayTimes.adjust({asr: this.props.asrMethod});
            let offset = this.props.dst*60;
            prayTimes.tune( {sunrise: offset, sunset: offset, fajr: offset, dhuhr: offset, asr: offset, maghrib: offset, isha: offset} );
            const times = prayTimes.getTimes(currentDate, [this.props.lat, this.props.lng], this.props.timeZone, 0, this.props.format);
            return (
                <tr key={currentDate.getDate()} className={ currentDate.getDate()%2 ? 'PtSecondBgColor' : 'PtFirstBgColor' }>
                    <td align="center" width="11%" ><font color="purple">{moment(currentDate).format('iD')}</font></td>
                    <td align="center" width="11%" >{moment(currentDate).format('MMM D, ddd')}</td>
                    <td align="center" width="11%" >{times.fajr}</td>
                    <td align="center" width="11%" >{times.sunrise}</td>
                    <td align="center" width="11%" >{times.dhuhr}</td>
                    <td align="center" width="11%" >{times.asr}</td>
                    <td align="center" width="11%" >{times.maghrib}</td>
                    <td align="center" width="11%" >{times.isha}</td>
                </tr>
            );
        });
    }

    render() {
        return (
            <div className="PrayTimesTable">
                <table id="Table_01" width="598"  border="0" cellPadding="0" cellSpacing="0">
                    <tbody>
                        <tr>
                            <td rowSpan="4" height="875" >
                                <img src={process.env.PUBLIC_URL+'/images/'+this.props.style+'/LeftBorder.jpg?ver='+window.settings.ver} alt="Left Border" height="900"/>
                            </td>
                            <td bgcolor="#FFFFFF">
                                <center>
                                        <img src={process.env.PUBLIC_URL+'/images/'+this.props.style+'/ICLogo.jpg?ver='+window.settings.ver}  alt="IslamiCity" width="419" height="58"/>
                                </center>			
                            </td>
                            <td rowSpan="4" height="870" >
                                <img src={process.env.PUBLIC_URL+'/images/'+this.props.style+'/RightBorder.jpg?ver='+window.settings.ver}  alt="Right Border" height="900"/> 
                            </td>
                        </tr>
                        <tr>
                            <td width="419" height="97" >
                                <center>
                                    <font className='PrayTitleText'>PRAYER TIMES</font><br/>
                                    <i><font className='CityTitleText'>&nbsp;{this.props.address}</font></i><br/>
                                    <font className='LatLongText'><font size="2"><b>Latitude:</b> {this.props.lat.toFixed(2)} &nbsp;&nbsp;&nbsp;<b>Longitude:</b> {this.props.lng.toFixed(2)}</font></font><br/>
                                    {/* <font className='QiblaText'><b>Qibla: 23:43:5 E (From N)</b></font> */}
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td width="419"  >
                                <center><font className='MonthTitleText'>{moment(this.props.date).format('D MMMM YYYY')} - {moment(this.props.date).add(1,'Month').format('D MMMM YYYY')}</font></center><center>
                                {/* <font className='RangeText'>{moment(this.props.date).format('iMMMM iYYYY')}</font></center> */}
                                <font className='RangeText'>Ramadan 1442</font></center>
                                <center><br/>
                                    <table className='ptmain' width="95%">
                                        <tbody>
                                            <tr className='ptheader'>
                                                {/* <td><center>{moment(this.props.date).format('iMMMM')}</center></td> */}
                                                <td><center>Day</center></td>
                                                <td><center>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</center></td>
                                                <td><center>Fajr<br/><font size="1">(Sahur)</font></center></td>
                                                <td><center>Shorook<br/><font size="1">(Sunrise)</font></center></td>
                                                <td><center>Zuhr<br/><font size="1">(Noon)</font></center></td>
                                                <td><center>Asr<br/><font size="1">(Afternoon)</font></center></td>
                                                <td><center>Maghrib<br/><font size="1">(Iftar)</font></center></td>
                                                <td><center>Isha<br/><font size="1">(Night)</font></center></td>
                                            </tr>
                                            {this.renderTable()}
                                        </tbody>
                                    </table>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td bgcolor="#FFFFFF">
                                <font className='sponsorText'></font>
                            </td>			
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

}

PrayTimesTable.defaultProps = {
    date: new Date(),
    format: '12hNS',
    style: 'style1'
}

PrayTimesTable.propTypes = {
    date: PropTypes.instanceOf(Date),
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    timeZone: PropTypes.number.isRequired,
    dst: PropTypes.number.isRequired,
    format: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    style: PropTypes.string.isRequired
}

export default PrayTimesTable;